import React, { Component } from "react";
import _ from 'lodash';
import ReadOnlyAuditScreen from '../DynamicForm/ReadOnlyAuditScreen'
import {Modal} from 'react-bootstrap';
export default class AgentScreen  extends Component {
  render(){    
    let auditorJson = {'templateValue':this.props.object.auditFormWithFeedback}
    let fieldValue = _.cloneDeep(this.props.object)
    let arrayobj=[];
    delete fieldValue.auditFormWithFeedback
    delete fieldValue.id
    arrayobj.push(
      {'label':'Auditor Name', 'value': fieldValue.auditorName},
      {'label':'Agent Name', 'value': fieldValue.agentName},
      {'label':'Skill Set', 'value': fieldValue.skillSetName},
      {'label':'Tenure', 'value': fieldValue.tenure},
      {'label':'TL Name', 'value': fieldValue.tlName},
      {'label':'Audited Date', 'value': fieldValue.updated_date},
      {'label':'Mobile number', 'value': fieldValue.msisdn},
      {'label':'Call Date', 'value': fieldValue.callDate},
      {'label':'Region', 'value': fieldValue.regionName},
      {'label':'Center', 'value': fieldValue.centerName},
      {'label':'Client', 'value': fieldValue.clientName}, 
      {'label':'Process', 'value': fieldValue.processName},
      {'label':'Case Type', 'value': fieldValue.caseType},
      {'label':'Call Sub Type1', 'value': fieldValue.callSubType1},
      {'label':'Case Sub Type2', 'value': fieldValue.callSubType2},
      {'label':'Case Sub Type3', 'value': fieldValue.callSubType3},
      {'label':'Case Sub Type4', 'value': fieldValue.callSubType4})
    return(
      <Modal
      show={true}
      onHide={this.props.closeModal}
      dialogClassName="modal-120w clientrecordxl"
      size="xl"
      backdrop='static'            
      keyboard={false}
     //aria-labelledby="contained-modal-title-vcenter"
      centered
      >
      <Modal.Header closeButton>
      <Modal.Title id="example-custom-modal-styling-title">
        Evaluation Form For - {this.props.title}
      </Modal.Title>
      </Modal.Header>
      <Modal.Body><ReadOnlyAuditScreen auditorJson={auditorJson} fieldValue = {arrayobj} loginUserName={this.props.loginUserName}
         CompletedAuditsView={this.props.CompletedAuditsView} ScoreCalculation={this.props.ScoreCalculation}
        action={this.props.action} closeModal={this.props.closeModal} id={this.props.object.id} /></Modal.Body>
      </Modal>

    )
  }
}